import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CircularProgress, Box, Typography, Paper } from '@mui/material';
import AppColors from '../../utils/AppColors';

const SuperAdminRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <Box 
                display="flex" 
                justifyContent="center" 
                alignItems="center" 
                minHeight="100vh"
            >
                <CircularProgress />
            </Box>
        );
    }

    // Redirect to login if not authenticated
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Show access denied for regular admins
    if (user.role !== 'super_admin') {
        return (
            <Box 
                display="flex" 
                justifyContent="center" 
                alignItems="center" 
                minHeight="100vh"
                sx={{ backgroundColor: AppColors.backgroundLightGray, p: 2 }}
            >
                <Paper 
                    elevation={3} 
                    sx={{ 
                        p: 4, 
                        textAlign: 'center',
                        maxWidth: 400,
                        borderRadius: '16px'
                    }}
                >
                    <Typography 
                        variant="h5" 
                        color="error" 
                        gutterBottom
                        sx={{ fontWeight: 'bold' }}
                    >
                        Access Denied
                    </Typography>
                    <Typography 
                        variant="body1" 
                        color="textSecondary"
                        sx={{ mb: 2 }}
                    >
                        You don't have permission to access this page. Only super administrators can manage other admins.
                    </Typography>
                    <Typography 
                        variant="body2" 
                        color="textSecondary"
                    >
                        Contact your super administrator if you need access to this feature.
                    </Typography>
                </Paper>
            </Box>
        );
    }

    return children;
};

export default SuperAdminRoute;